<ul>
    <c-tree-view-node ng-repeat="child in treeView.tree track by $index" node="child" tree-view="treeView"></c-tree-view-node>
</ul>